import PropTypes from "prop-types"
import { map, isPlainObject } from "lodash"
import classNames from "classnames"
import OPTooltip from "components/material/tooltip"
import { InfoOutlined } from "@mui/icons-material"
import { getMetricSignClass } from "helpers/metrics/utils"
import { useFlashOnChange } from "hooks/use-flash-on-change"

function SummaryValueCell({ summary, formatter, className }) {
  const rawValue = isPlainObject(summary) && "value" in summary ? summary.value : summary
  const flashRef = useFlashOnChange(rawValue)
  const formattedValue = rawValue == null ? "-" : formatter(rawValue)
  const isPerformanceMetric = isPlainObject(summary) ? summary.isPerformanceMetric : false
  const performanceClassName = isPerformanceMetric ? classNames("metric-value", getMetricSignClass(rawValue)) : null
  const valueContent = performanceClassName ? <span className={performanceClassName}>{formattedValue}</span> : formattedValue
  const tooltip = isPlainObject(summary) ? summary.tooltip : null
  return (
    <div ref={flashRef} className={className}>
      {tooltip ? (
        <OPTooltip title={tooltip}>
          <span className="summary-with-tooltip">
            <InfoOutlined fontSize="small" className="summary-tooltip-icon" />
            {valueContent}
          </span>
        </OPTooltip>
      ) : valueContent}
    </div>
  )
}

SummaryValueCell.propTypes = {
  summary: PropTypes.any,
  formatter: PropTypes.func.isRequired,
  className: PropTypes.string,
}

export default function SummaryValues({ summary, formatter, className = "summary-value" }) {
  return map(summary, (summaryItem, index) => (
    <SummaryValueCell key={index} summary={summaryItem} formatter={formatter} className={className} />
  ))
}

SummaryValues.propTypes = {
  summary: PropTypes.array.isRequired,
  formatter: PropTypes.func.isRequired,
  className: PropTypes.string,
}
